import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

function BookingPreview() {
  const history = useHistory();
  return (
    <div>
      booking preview page
      <button onClick={() => history.goBack()}>go back</button>
    </div>
  );
}

export default BookingPreview;
